module.exports = __webpack_public_path__ + "static/media/dimensions-blurred.0619c752.jpg";